import { createIamHttpAuthPolicy } from '@modules/iam';
import { configureHttpAuthPolicy } from '@shared/api/http';

export function configureApp(): void {
  configureHttpAuthPolicy(createIamHttpAuthPolicy());
}